import React, { useState } from 'react';
import { Plus, Printer, FileText, CalendarClock } from 'lucide-react';
import Modal from './Modal';
import { api } from '../lib/api';

export default function SectionHospitalizations({ patient, user, afterChange, notify, modal, setModal }) {
    const [data, setData] = useState(patient.hospitalizations || []);
    const [busy, setBusy] = useState(false);

    async function refresh() {
        const r = await api(`/patients/${patient.id}/hospitalizations`);
        setData(r.hospitalizations);
    }

    async function save(e) {
        e.preventDefault(); setBusy(true);
        try {
            const body = {
                hospital_name: e.target.hospital_name.value,
                status: e.target.status.value,
                admitted_at: e.target.admitted_at.value,
                reason: e.target.reason.value,
            };
            await api(`/patients/${patient.id}/hospitalizations`, { method: 'POST', body });
            await refresh();
            await afterChange('Hospitalization recorded.');
            setModal(null);
        } catch (err) { notify(err.message); }
        finally { setBusy(false); }
    }

    return (
        <section className="content-card">
            <div className="content-heading">
                <div><h3>Hospitalizations</h3><p>ED, observation, and inpatient stays.</p></div>
                {user.role === 'clinic_admin' && <button className="button primary" onClick={() => setModal({ type: 'hospitalization' })}><Plus size={15}/>Add stay</button>}
            </div>
            <div className="table-scroll">
                <table>
                    <thead>
                        <tr><th>Admitted</th><th>Hospital</th><th>Status</th><th>Reason</th><th>Discharged</th><th>Actions</th></tr>
                    </thead>
                    <tbody>
                        {data.map(h => (
                            <tr key={h.id}>
                                <td>{h.admitted_at}</td>
                                <td><strong>{h.hospital_name}</strong></td>
                                <td><span className="badge neutral">{h.status}</span></td>
                                <td>{h.reason}</td>
                                <td>{h.discharged_at || '—'}</td>
                                <td><button className="text-button" onClick={() => setModal({ type: 'hospitalization', id: h.id })}>Edit</button></td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                {!data.length && <p className="empty-copy">No hospitalization records.</p>}
            </div>
        </section>
    );
}
